import { Responsive, TDeviceType } from '@cian/ui-kit';
import { LinkButton } from '@cian/ui-kit/button';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { ElectronicTradingButtonContainer } from '../../containers/ElectronicTradesButtonContainer';
import { ECommunicationType } from '../../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import { IPageState } from '../../types/page';
import { IFavoriteEntity, IJKInfo } from '../../types/results';
import { BookButton } from '../BookButton';
import { ShowPhone } from '../ShowPhone';

interface ITabletCardControls {
  favoriteEntity: IFavoriteEntity;
  phone?: string | null;
  fullUrl: string;
  jkInfo?: IJKInfo | null;
  communicationType: ECommunicationType | null;
  page: IPageState;
  total: number;
  position: number;

  trackPhoneClick(): void;
  trackJKButtonClick(): void;
}

export const TabletCardControls: React.FC<ITabletCardControls> = ({
  favoriteEntity,
  phone,
  jkInfo,
  fullUrl,
  trackPhoneClick,
  trackJKButtonClick,
  communicationType,
  page,
  total,
  position,
}) => {
  const { isCianPartner, tradingLink } = favoriteEntity;

  const isElectronicTradingAvailable = !!tradingLink;

  const actionButton = (() => {
    if (isElectronicTradingAvailable) {
      return <ElectronicTradingButtonContainer favoriteEntity={favoriteEntity} deviceType={'tablet' as TDeviceType} />;
    }

    if (communicationType === ECommunicationType.Forms) {
      return (
        <LinkButton href={`${fullUrl}?opendealrentform=true`} fullWidth>
          Назначить просмотр
        </LinkButton>
      );
    }

    if (isCianPartner) {
      return <BookButton phone={phone} favoriteEntity={favoriteEntity} page={page} total={total} position={position} />;
    }

    return phone && <ShowPhone phones={[phone]} withNote trackClick={trackPhoneClick} />;
  })();

  return (
    <Responsive tablet>
      {actionButton && <div className={classNames(styles['controls-tablet-cell'])}>{actionButton}</div>}
      {jkInfo && (
        <div className={classNames(styles['controls-tablet-cell'])}>
          <LinkButton size="XS" href={fullUrl} onClick={trackJKButtonClick}>
            Перейти к ЖК
          </LinkButton>
        </div>
      )}
    </Responsive>
  );
};
